import LIFFAddRequest from './apis/liff-add-request';
import LIFFListRequest from './apis/liff-list-request';
import LIFFRemoveRequest from './apis/liff-remove-request';
import LIFFRequest from './apis/liff-request';
import LINETvGetCategoryRequest from './apis/linetv-get-category-request';
import LINETvGetSpotlightRequest from './apis/linetv-get-sportlight-request';
import LINETvGetStationRequest from './apis/linetv-get-station-request';
import LINETvListCategoryRequest from './apis/linetv-list-catagory-request';
import LINETvListModulesRequest from './apis/linetv-list-modules-request';
import LINETvListStationRequest from './apis/linetv-list-station-request';
import LINETvLiveRequest from './apis/linetv-live-request';
import LINETvRankingRequest from './apis/linetv-ranking-request';
import LINETvRequest from './apis/linetv-request';
import OAuthIssueTokenRequest from './apis/oauth-issue-token-request';
import OAuthRequest from './apis/oauth-request';
import OAuthRevokeTokenRequest from './apis/oauth-revoke-token-request';
import RichMenuAddRequest from './apis/rich-menu-add-request';
import RichMenuListRequest from './apis/rich-menu-list-request';
import RichMenuRemoveRequest from './apis/rich-menu-remove-request';
import RichMenuRequest from './apis/rich-menu-request';
import RichMenuSetDefaultRequest from './apis/rich-menu-set-default-request';
import RichMenuUploadRequest from './apis/rich-menu-upload-request';
import ThingsAddTrialRequest from './apis/things-add-trial-request';
import ThingsGetDeviceByDeviceUserRequest from './apis/things-get-device-by-device-user-request';
import ThingsGetDeviceRequest from './apis/things-get-device-request';
import ThingsGetDevicesByProductUserRequest from './apis/things-get-devices-by-product-user-request';
import ThingsGetProductScenarioSetRequest from './apis/things-get-product-scenario-set-request';
import ThingsListTrialProductsRequest from './apis/things-list-trial-products-request';
import ThingsRemoveProductScenarioSetRequest from './apis/things-remove-product-scenario-set-request';
import ThingsRemoveTrialProductRequest from './apis/things-remove-trial-product-request';
import ThingsRequest from './apis/things-request';
import ThingsUpdateProductScenarioSetRequest from './apis/things-update-product-scenario-set-request';

const apis = {
  LIFFAddRequest,
  LIFFListRequest,
  LIFFRemoveRequest,
  LIFFRequest,
  LINETvGetCategoryRequest,
  LINETvGetSpotlightRequest,
  LINETvGetStationRequest,
  LINETvListCategoryRequest,
  LINETvListModulesRequest,
  LINETvListStationRequest,
  LINETvLiveRequest,
  LINETvRankingRequest,
  LINETvRequest,
  OAuthIssueTokenRequest,
  OAuthRequest,
  OAuthRevokeTokenRequest,
  RichMenuAddRequest,
  RichMenuListRequest,
  RichMenuRemoveRequest,
  RichMenuRequest,
  RichMenuSetDefaultRequest,
  RichMenuUploadRequest,
  ThingsAddTrialRequest,
  ThingsGetDeviceByDeviceUserRequest,
  ThingsGetDeviceRequest,
  ThingsGetDevicesByProductUserRequest,
  ThingsGetProductScenarioSetRequest,
  ThingsListTrialProductsRequest,
  ThingsRemoveProductScenarioSetRequest,
  ThingsRemoveTrialProductRequest,
  ThingsRequest,
  ThingsUpdateProductScenarioSetRequest
};

export default apis;
